








import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office, getOtherCompanies } from "@/api/company-api";

import EndUserShow from "@/templates/EndUserShow.vue";

@Component({
  components: {
    EndUserShow
  }
})
export default class CompanyShowPage extends Vue {
  @Prop({ required: true }) id!: string;
  query = "";

  created() {
    this.initCompanies();
  }

  edit() {
    const params = { id: this.id };
    this.$router.push({ name: "enduser-edit", params });
  }

  cancel() {
    this.$router.push({ name: "enduser-list" });
  }

  private companies: Company[] = [];
  private company: Company | null = null;
  private office: Office | null = null;

  private async initCompanies() {
    this.companies = await getOtherCompanies();
    this.selectCompany();
  }

  @Watch("id")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.id);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
    } else {
      this.company = null;
      this.office = null;
    }
  }
}
